export default () => ({
  root: {
    padding: '0 50px',
  },
})
